import { _reference } from './pn/_reference';
import { elevationContours } from './pn/elevationContours';
import { grids } from './pn/grids';

export const pnMapboxLayers = [
  ...elevationContours('dark'),
  _reference,
  ...grids('dark'),
] as mapboxgl.AnyLayer[];

export const bottomGridsLayerId = 'township-labels';

export const gridLayerIds: Record<string, string[]> = {
  township: ['township-grid', 'township-labels'],
  section: ['section-grid', 'section-labels'],
  quarterSection: ['quarter-section-grid', 'quarter-section-labels'],
  lsd: ['lsd-grid', 'lsd-labels'],
  block: ['nts-block-grid', 'nts-block-labels'],
  unit: ['nts-unit-grid', 'nts-unit-labels'],
  county: ['county-grid', 'county-labels'],
  abstract: ['abstract-grid', 'abstract-labels'],
};

export const gridLayerLabels: Record<string, string> = {
  township: 'Townships',
  section: 'Sections',
  quarterSection: 'Quarter Sections',
  lsd: 'LSDs',
  block: 'NTS Blocks',
  unit: 'NTS Units',
  county: 'Counties',
  abstract: 'Abstracts',
};
